import {styled} from "@mui/material";

export const ProgressWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
});
